exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.weui-bar__item_on {\n  border-bottom: 1px solid #247e3b;\n}\n.weui-bar__item_on .weui-tabbar__label {\n  color: #247e3b !important;\n}\n.popup-div {\n  overflow: hidden;\n  width: 100%;\n  margin: 20px auto 45px;\n}\n.popup-div li {\n  width: 33.3vw;\n  float: left;\n  text-align: center;\n  color: #888;\n  font-size: 14px;\n  line-height: 30px;\n  margin-bottom: 5px;\n}\n.popup-div li img {\n  width: 50px;\n}\n.popup-div li a,\n.popup-div li a:hover,\n.popup-div li a:active {\n  color: #888;\n}\n", ""]);

// exports
